export default "__VITE_ASSET__DI5e6JSS__"